import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import CropperScaffold from '../../common/forms/CropperScaffold';
import Loading from '../../common/components/Loading';
import ReduxFormsImageCropper from '../../common/forms/ReduxFormsImageCropper';

const validate = values => {
  const errors = {};
  const { image, image_id } = values;

  if (!image && !image_id) {
    errors.image = ['Please select a category thumbnail'];
  }

  return errors;
};

class CategoryEditForm extends Component {
  static propTypes = {
    ...formPropTypes,
    clearOrigImage: PropTypes.bool,
    onCancel: PropTypes.func,
    removeImage: PropTypes.func,
    category: PropTypes.object,
  };

  render() {
    const { clearOrigImage, handleSubmit, onCancel, removeImage, category, submitting } = this.props;

    if (submitting) {
      return <Loading />;
    }
    return (
      <div className="admin-paper__edit-content">
        <form onSubmit={handleSubmit}>
          {category && category.get('image_id') && !clearOrigImage ? (
            <CropperScaffold label="Category Thumbnail" required>
              <div className="original-image">
                <img alt="category thumbnail" src={category.getIn(['image', 'location'])} />
              </div>
              <div className="cropper-scaffold__controls">
                <button type="button" className="button button--theme--outline" onClick={removeImage}>
                  Remove Image
                </button>
              </div>
            </CropperScaffold>
          ) : (
            <Field name="image" component={ReduxFormsImageCropper} label="Category Thumbnail" />
          )}
          <div className="admin-paper__edit-content__button-row">
            <div>
              <button type="button" className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
                Cancel
              </button>
              <button type="submit" className="button" disabled={submitting}>
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'CategoryEditForm',
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
  validate,
})(CategoryEditForm);



// WEBPACK FOOTER //
// ./src/library/categories/CategoryEditForm.js